export const UPDATE = 'alerts/actions/UPDATE';

export const initialState = {
  isShown: false,
  msg: '',
  level: 'error',
  variant: 'filled',
};

/**
 * Shows the popup alert at the top of the report building steps, configurable with different levels.
 * @param isShown Whether or not the alert is shown
 * @param msg The message displayed with the alert
 * @param level Affects alert styling, mainly the color. Expects a value from ['success', 'error', 'info', 'warning']
 * @param variant Affects alert styling, mainly the background. Expects a value from ['filled', , 'outlined', 'standard']
 * @returns {{payload: {msg: string, level: string, variant: string, isShown: boolean}, type: string}}
 */
export function updateReportAlert(
  {
    isShown = false,
    msg = '',
    level = 'error',
    variant = 'filled',
  }
) {
  return {
    type: UPDATE,
    payload: {
      isShown,
      msg,
      level,
      variant,
    }
  };
}

/**
 * Helper for a general report generation alert
 * @param isShown
 * @returns {{payload: {msg: string, level: string, variant: string, isShown: boolean}, type: string}}
 * @see updateReportAlert
 */
export function toggleReportGenerationErrorAlert(isShown = false) {
  return updateReportAlert({
    isShown,
    msg: 'Error encountered creating report',
    level: 'error',
    variant: 'filled',
  });
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
